import React from "react";
import './styles.scss';

const SVG = ({ attributes, content, className, style }) => {

  const { code } = attributes;

  return React.createElement(
    "div",
    {
      className: className,
      style: style,
      dangerouslySetInnerHTML: { __html: code },
    },
  );
};

export default SVG;
